import React from "react";
import {ChipLabel} from "./index";

const HealthChips = ({entity}) => {
    return (
        <React.Fragment>
            {
                entity.health_rank === 'red' && <ChipLabel label={"Poor"} className={"data-access-chip error"}/>
            }
            {
                entity.health_rank === 'green' && <ChipLabel label={"Good"} className={"data-access-chip create"}/>
            }
            {
                entity.health_rank === 'yellow' && <ChipLabel label={"Average"} className={"data-access-chip warning"}/>
            }
            {
                !entity.health_rank && <ChipLabel label={"Unknown"} className={"data-access-chip unknown"}/>
            }
        </React.Fragment>
    )
}

export default HealthChips;